import React, { useState } from 'react';
import { Construction, LogIn, LogOut, ArrowUpRight } from 'lucide-react';
import { useAuth } from '../../auth';
import { useTheme } from '../../theme';
import { Button } from '../ui/button';
import { MaintenanceRounds } from './MaintenanceRounds';
import { MaintenanceSocials } from './MaintenanceSocials';
import AuthDialog from '../AuthDialog';
import Sidebar from '../Sidebar';
import { ConstructionCountdown } from './ConstructionCountdown';

export const MaintenancePage = ({ settings, onExpire }) => {
  const { user, logout } = useAuth();
  const { theme } = useTheme();
  const [authOpen, setAuthOpen] = useState(false);
  const openLogin = () => setAuthOpen(true);
  return <>
    <Sidebar restricted onAuth={openLogin} />
    <div className="maintenance-shell" data-testid="maintenance-shell">
      <main className="maintenance-page maintenance-redesign" data-testid="maintenance-page">
        <img className="maintenance-logo" src={theme === 'venom' ? '/gv-logo.png' : '/gv-logo-onyx.png'} alt="GVRewards" data-testid="maintenance-logo" />
        <div className="maintenance-barricade" aria-hidden="true" data-testid="maintenance-barricade"><div className="maintenance-barricade-post left" /><div className="maintenance-barricade-post right" /><div className="maintenance-barricade-beam"><span /><span /></div></div>
        <div className="maintenance-status" data-testid="maintenance-status"><Construction size={15} aria-hidden="true" />A little work behind the scenes</div>
        <h1 className="font-display" data-testid="maintenance-title">Under construction<span className="maintenance-title-stop" aria-hidden="true">.</span></h1>
        <p className="maintenance-description" data-testid="maintenance-description">We’re making GVRewards even better.<br />Thanks for being part of what comes next.</p>
        <ConstructionCountdown settings={settings} onExpire={onExpire} />
        {user ? <div className="maintenance-account"><p data-testid="maintenance-user">Signed in as <strong>{user.username}</strong></p><Button className="maintenance-primary" onClick={logout} data-testid="maintenance-logout"><LogOut size={17} />Log out</Button></div> : <Button className="maintenance-primary" onClick={openLogin} data-testid="maintenance-login-toggle"><LogIn size={17} />Log in<ArrowUpRight size={16} aria-hidden="true" /></Button>}
        <MaintenanceSocials />
        <MaintenanceRounds key={user?.id || 'demo'} user={user} />
      </main>
    </div>
    <AuthDialog open={authOpen} onOpenChange={setAuthOpen} mode="login" setMode={() => {}} loginOnly />
  </>;
};